
  <div class="content table-responsive">
    <table class="table">
      <tbody>
          <tr *ngFor="let row of data.dataRows">
            <!-- <td *ngFor="let cell of row">{{ cell }}</td> -->
            <td>
                <div class="flag">
                    <img *ngIf="row[O] !== ''" src="./assets/img/flags/{{row[0]}}.png" alt="">
                    <span *ngIf="row[0] == ''">&bull;</span>
                </div>
            </td>
            <td>
                {{row[1]}}
            </td>
            <td class="text-right">
                {{row[2]}}
            </td>
            <td class="text-right">
                {{row[3]}}
            </td>
          </tr>
      </tbody>
    </table>

  </div>
